/**
 * Image component
 * 
 */

import React, { PureComponent } from 'react';

export default class Image extends PureComponent {

	render() {
		
		const { url, dimensions, alt, retina } = this.props.data;
		const { classes, width, height } = this.props;
		
		if (url) {

			const srcset = url + ' 1x, ' + (retina === undefined ? url : retina.url) + ' 2x';

			return (

				<img src={url} srcSet={srcset} className={classes} width={width ? width : dimensions.width} height={height ? height : dimensions.height} alt={alt||''} />
			);
		}
		else {

			return null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/image/image.js